import {gsap, TimelineLite} from "gsap";
import {DFGameConfig} from "../DFGameConfig";
import {BitmapText} from "pixi.js";
import {DumpsterFireGameAssets} from "../DumpsterFireGameAssets";
import {DumpsterFire} from "../DumpsterFire";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class DFScatterView extends PIXI.Container implements StageLayer {
    private _scatterSpineArray: PIXI.Container = new PIXI.Container();
    private _activeAnimations: TimelineLite[] = []

    constructor() {
        super();
        this.name = "DFScatterView";
        this.addChild(this._scatterSpineArray);
    }

    public onResize() {
        this._activeAnimations.forEach((tl: TimelineLite) => {
            tl.kill();
            tl.progress(1);
        });
    }

    public extraSpinAward(reelId: number, rowId: number, toPosX: number, toPosY: number, text: string): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            extraSpinFont: BitmapText = new BitmapText(text, {
                fontName: DumpsterFireGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 26
            });
        extraSpinFont.scale.set(0.9);
        extraSpinFont.anchor = new PIXI.Point(0.5, 0.5);
        let duration: number = reelId <= 3 ? 0.6 : 0.4,
            xPos: number = 50 + (DFGameConfig.symbolWidth * reelId),
            yPos: number = 120 + (DFGameConfig.symbolHeight * rowId);
        extraSpinFont.position.set(xPos, yPos);
        extraSpinFont.alpha = 0;
        extraSpinFont.visible = false;
        this.addChild(extraSpinFont);
        tl.add([
            () => {
                extraSpinFont.visible = true;
            },
            gsap.to(extraSpinFont, {duration: 0, alpha: 1})
        ]);
        tl.add(
            gsap.fromTo(extraSpinFont.position, {x: xPos, y: yPos}, {
                duration: duration, x: toPosX, y: toPosY, ease: "none", onComplete: () => {
                    gsap.fromTo(extraSpinFont.scale, {scale: 1}, {
                        duration: 0, scale: 0, ease: "none"
                    })
                }
            }), ">");
        this._activeAnimations.push(tl);
        if (!NolimitApplication.isLandscape) {
            tl.add(gsap.to(extraSpinFont, {duration: 0.2, alpha: 0, delay: 0}), `<${duration - 0.2}`);
        }else{
            tl.add(gsap.to(extraSpinFont, {duration: 0.1, alpha: 0, delay: 0}), ">");
        }
        tl.add(() => {
            if (extraSpinFont.parent) {
                this.removeChild(extraSpinFont);
                DumpsterFire.keypadPlugin.setZeroBetSpinCounter(DumpsterFire.model.gameData.freespinsLeft);
            }
        });
        return tl;
    }
}